import { useState } from 'react'
import { SystemSS } from '../../../components/SystemSS'
import { FullScreenModal } from '../../../utility/FullScreenModal'
export const FacilitiesAwakening = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
        console.log('clickd')
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            {' '}
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-awakening-fr.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        En utilisant Éveil / Réincarnation, vous pouvez{' '}
                        <sapn className='text-pborange'>changer la classe d'une unité</sapn> ou{' '}
                        <sapn className='text-pborange'>augmenter l'Expirite (bonus de statistique)</sapn>.
                    </p>{' '}
                    <br />
                    <p className='mt-4'>
                        Éveil est une fonctionnalité de renforcement d'unité qui vous permet de{' '}
                        <sapn className='text-pborange'>conserver</sapn> le niveau actuel de l'unité, tout en recevant
                        la quantité correspondante d'Expirite.
                    </p>
                    <br />
                    <p>
                        C'est un <sapn className='text-pborange'>super moyen</sapn> de garder une classe, une espèce et
                        un niveau identiques, tout en continuant à faire progresser l'unité.
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'awakening',
                                index: 1,
                            },
                        ]}
                        description={
                            "Utilisez l'Expirite pour ajouter des bonus de statistique et renforcer vos unités !"
                        }
                        handleOpenModal={handleOpenModal}
                    />{' '}
                    <p>
                        Réincarnation est un système qui permet à un personnage de changer de classe ou d'espèce, et de
                        retourner au niveau 1 tout en <sapn className='text-pborange'>conservant</sapn> ses Capacités,
                        ses Compétences et son Titre.
                    </p>{' '}
                    <br />
                    <p>
                        Lors d'une Réincarnation, vous recevrez l'équivalent en Expirite du niveau actuel du personnage,
                        que vous pourrez alors redistribuer dans ses statistiques, ce qui le rendra bien plus puissant
                        qu'une unité de niveau 1 normale. De plus, comme le personnage conserve les Compétences et les
                        Capacités de sa classe ou espèce précédente, il deviendra une unité{' '}
                        <sapn className='text-pborange'>assez exceptionnelle</sapn>.
                    </p>{' '}
                    <br />
                    <p>
                        Pour que vous puissiez utiliser Éveil ou Réincarnation, des objets très importants, appelés «
                        Livres de la Métamorphose » et « Œufs », sont nécessaires.
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'awakening',
                                index: 2,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description='Un Combattant réincarné en Sorcière conserve la Compétence de Combattant Cri désespéré.'
                    />{' '}
                </div>{' '}
            </section>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={2}
            />
        </>
    )
}
